module.exports = __webpack_public_path__ + "img/用户构建.a68959d9.png";